<!-- 
<div class="desktop-gamedropdown position-relative" (click)="displayDropdown = !displayDropdown"
  *ngIf="constant.tmpGameList.length && constant.GameCode.trim() !== '' && constant.lobbyGameDropDown">
  <span>
    {{constant.GameCode.trim() ? translateService.instant(constant.GameCode.trim()): ''}}
  </span>
  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.96478 5.657L0.316406 1.414L1.8666 0L4.96478 2.829L8.06297 0L9.61316 1.414L4.96478 5.657Z"
      fill="white" />
  </svg>
  <ul class="dropdown-menu dropdown-menu-end" [ngStyle]="{display:displayDropdown?'block':'none'}">
    <li *ngFor="let game of constant.tmpGameList;let i=index">
      <a class="dropdown-item active" (click)="checkGameStatus(game,i)"
        [ngClass]="{'active': constant.GameCode.trim() == game.GameCode.trim()}">
        {{translateService.instant(game.GameCode.trim())}}</a>
    </li>
  </ul>
</div>
<div class="navDrop mobile-gamedropdown" *ngIf="constant.lobbyGameDropDown">
  <div class="navDropdown ">
    <div class="dropdown">
      <div class="dropbtn" (click)="displayDropdown = !displayDropdown">
        {{constant.GameCode.trim() ? translateService.instant(constant.GameCode.trim()): ''}}
        <svg *ngIf="!displayDropdown" fill="white" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
          viewBox="0 0 24 24">
          <path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z" />
        </svg>
        <svg *ngIf="displayDropdown" fill="white" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
          viewBox="0 0 24 24">
          <path d="M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z" />
        </svg>
      </div>
      <div class="dropdown-content"
        *ngIf="displayDropdown === true && constant.tmpGameList.length && constant.GameCode.trim() !== ''">
        <div class="dropdown-sub-content">
          <a *ngFor="let game of constant.tmpGameList;let i=index"
            [ngClass]="{'active': constant.GameCode.trim() == game.GameCode.trim()}"
            (click)="displayDropdown = false;checkGameStatus(game,i)">
            {{translateService.instant(game.GameCode.trim())}} 
          </a>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!-- <div class="col-md-12" *ngIf="constant.gameList.length">
  <div class="row">
    <div class="col-sm-4">
      <label class="ds-game-name">{{gameNameSet(this.constant.gameName)}}</label>
    </div>
    <div class="col-sm-8">
      <marquee class="marquee">
        <span *ngFor="let item of constant.newsList">
          <strong><span class="marquee_news" *ngIf="item.GameID == -1">&nbsp;&nbsp; ✺ {{item.Title}}</span></strong>
          <strong><span class="marquee_news" *ngIf="item.GameID == constant.gameId">&nbsp;&nbsp; ✺
              {{item.Title}}</span></strong>
        </span>
      </marquee>
    </div>
  </div>
</div> -->

<ng-container *ngIf="constant.tmpGameList.length">
  <div class="col-md-12 slider-row">
    <div class="navSlider" style="position: relative;">
      <swiper [config]="config" (indexChange)="onIndexChange($event)" *ngIf="this.constant.isLobbyShowLive === true || this.constant.isLobbyShowVirtual === true">
        <ng-container *ngFor="let game of constant.tmpGameList;let i=index">
          <div class="swiper-slide" [ngClass]="GameCode.trim() == game.GameCode.trim() ? 'swiper-slide-current' : ''"
            [value]="game.GameCode">
            <a class="text-decoration-none cb-hover-selector">
              <span></span>
              <div class="row" [attr.GameCode]="game.GameCode">
                {{translateService.instant(game.GameCode.trim())}}
              </div>
            </a>
          </div>
        </ng-container>
      </swiper>
    </div>
  </div>
</ng-container>


<div id="RulesPopup" class="modal fade modal-scroll" tabindex="-1" data-replace="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
          x
        </button>
        <h4 class="modal-title">Rules</h4>
      </div>
      <div class="modal-body text-left">
        <div [innerHtml]="CurrentGame.Rules"></div>
      </div>
    </div>
  </div>
</div>
<!-- Rules Pop Up Start -->
<div id="AgreeRulesPopup" class="modal fade modal-scroll" tabindex="-1" data-replace="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
          x
        </button>
        <h4 class="modal-title">Rules</h4>
      </div>
      <div class="modal-body text-left">
        <div [innerHtml]="SelectedGame?.Rules"></div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-md alert-success" data-dismiss="modal" aria-hidden="true">I Agree
        </button>
        <button type="button" class="btn btn-md alert-danger" data-dismiss="modal" aria-hidden="true"> Disagree
        </button>
      </div>
    </div>
  </div>
</div>